import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GetPaymentResultDTO } from '@src/api/@types/GetPaymentResultDTO';
import { formatAmount, formatDays } from '@src/services/Formatter';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  payments?: GetPaymentResultDTO[];
  closedNextPayment?: boolean;
  daysToNextPayment?: string;
};

const PaymentsSpreadInfo: FC<Props> = ({ payments }) => {
  const { t } = useTranslation();

  if (!payments || payments.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column'}}> 
        <Typography  sx={{ fontSize: '1.5rem',fontWeight: 200, mb:3,mt: 3 }}>  
            {t('payment.nextPayment')}
          </Typography>
      {payments.map((payment) => (
        <Box key={payment.id} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>  
            <Box component="span" sx={{fontSize: '0.9rem', color: 'gray' }}> {formatDays(payment.plannedOnDateUTC)}</Box>
            <Stack
              direction="row"
              spacing={2}  
              justifyContent="space-between"
              alignItems="center"
              sx={{ fontWeight: 200 }}
            >
              <Typography variant="body2">  
              <Typography variant="body2" sx={{ mb: 0.2, mt:1 }}>   {t('payment.paymentBefore')}</Typography><br />
                <Box component="span" sx={{ fontSize: '2rem', color: 'white' }}>{formatAmount(payment.amount).dollars}</Box>
                <Box component="span" sx={{ fontSize: '2rem', color: 'gray' }}>.{formatAmount(payment.amount).cents}$</Box>
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {t('payment.paymentAfter')}<br />
                <Box component="span" sx={{ color: 'gray', fontWeight: 200  }}>{t('payment.contactForChanges')}</Box>
              </Typography>
            </Stack>
        </Box>
      ))}
    </Box>
  );
};

export default PaymentsSpreadInfo;
